<template>
    <div class="item_sidebar">
        <div class="wrapper_title mb_0">
            <div class="title">{{title}}</div>

            <div :class="['steps_toggler',{'active': value == 2}]">
                <div
                    :class="['steps_toggle_side',{'active': value == 1}]"
                    @click="changeStep(1)">
                    Step #1
                </div>
                <div
                    :class="['steps_toggle_side',{'active': value == 2}]"
                    @click="changeStep(2)">
                    Step #2
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'StepToggler',
    props: ['title', 'value'],
    methods: {
        changeStep(stepNumber) {
            this.$emit('updated', stepNumber);
        }
    }
}
</script>

<style lang="scss" scoped>

.steps_toggler {
	border: 1px solid #E4E6F1;
	border-radius: 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: auto;
	position: relative;

	&:before {
		content: "";
		display: block;
		height: 30px;
		width: 78px;
		background: $sharp-blue;
		position: absolute;
		left: 0;
		top: 0;
		border-radius: 15px;
		transition: 0.15s all ease-in-out;
	}
	&.active:before {
		left: 73px;
	}

}

.steps_toggle_side {
	padding: 6px 15px;
	font-weight: normal;
	font-size: 12px;
	line-height: 150%;
	display: block;
	letter-spacing: 0.02em;
	color: #C5C7D2;
	cursor: pointer;
	transition: 0.15s all ease-in-out;
	border-radius: 15px;
	white-space: nowrap;
	z-index: 2;

	&.active {
		color: #FFFFFF;
	}
	&:not(.active):hover {
		color: $sharp-blue;
	}
}

</style>
